module.exports = __webpack_public_path__ + "static/media/3500.dbb81b1f.png";